<template>
    <list-cell-dot :color="statusColor">
        <template #title>
            {{ pipeline.name }}
        </template>

        <template #subtitle>
            {{ status.label }}
        </template>
    </list-cell-dot>
</template>

<script setup lang="ts">
    import { Pipeline, Status } from '@keyvue/one-api-client';
    import { Color } from '@keyvue/one-ui';
    import { computed } from 'vue';

    const props = defineProps<{
        pipeline: Pipeline
        status: Status
    }>();

    const statusColor = computed(() => {
        if (props.status.equals(Status.WON)) {
            return Color.green500;
        }

        if (props.status.equals(Status.LOST)) {
            return Color.red500;
        }

        return Color.gray400;
    });
</script>
